<template lang="pug">
  SspLayout.recall-create(area="tnt")
    .row
      .col-md-4
        form.panel.panel-default(role="form" @submit.prevent="recallCodes()")
          .panel-heading.panel-title Codes
          .panel-body.form-horizontal
            .form-group
              .col-sm-12
                textarea.form-control(v-model="recall.codes" placeholder="Codes")
            .form-group
              .col-sm-12
                input.form-control(v-model="recall.codesDescription" placeholder="Description")
          .panel-footer
            .text-right
              SspActionButton(type="submit" text="Recall" :spinning="recallingCodes" :disabled="!isValidCodes")

      .col-md-4
        form.panel.panel-default(role="form" @submit.prevent="recallOrder()")
          .panel-heading.panel-title Order
          .panel-body.form-horizontal
            .form-group
              .col-sm-12
                input.form-control(v-model.numer="recall.orderId" type="number" placeholder="Order ID")
            .form-group
              .col-sm-12
                input.form-control(v-model="recall.orderDescription" placeholder="Description")
          .panel-footer
            .text-right
              SspActionButton(type="submit" text="Recall" :spinning="recallingOrder" :disabled="!isValidOrder")

      .col-md-4
        form.panel.panel-default(role="form" @submit.prevent="recallSection()")
          .panel-heading.panel-title Section
          .panel-body.form-horizontal
            .form-group
              .col-sm-12
                input.form-control(v-model.number="recall.sectionId" type="number" placeholder="Section ID")
            .form-group
              .col-sm-12
                input.form-control(v-model="recall.sectionDescription" placeholder="Description")
          .panel-footer
            .text-right
              SspActionButton(type="submit" text="Recall" :spinning="recallingSection" :disabled="!isValidSection")
</template>

<script>
import miniToastr from 'mini-toastr'
import TrackNTrace from '@/service/apis/TrackNTrace'
import Util from '@/service/Util'

export default {
  data() {
    return {
      recall: this.initData()
    }
  },
  methods: {
    initData() {
      return {
        codes: null,
        sectionId: null,
        orderId: null,
        recallingCodes: false,
        recallingSection: false,
        recallingOrder: false,
        codesDescription: null,
        orderDescription: null,
        sectionDescription: null
      }
    },
    success() {
      miniToastr.success('Recall successfully created')
      this.recall = this.initData()
      this.errorMsg = null
    },
    recallCodes() {
      this.recallingCodes = true
      const cleanCodes = Util.sanitizeCodes(this.recall.codes)

      const req = {
        codes: cleanCodes
      }
      TrackNTrace.recallCodes(req, this.recall.codesDescription)
        .then(() => {
          this.success()
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.recallingCodes = false
        })
    },
    recallSection() {
      this.recallingSection = true
      TrackNTrace.recallSection(this.recall.sectionId, this.recall.sectionDescription)
        .then(() => {
          this.success()
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.recallingSection = false
        })
    },
    recallOrder() {
      this.recallingOrder = true
      TrackNTrace.recallOrder(this.recall.orderId, this.recall.orderDescription)
        .then(() => {
          this.success()
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.recallingOrder = false
        })
    }
  },
  computed: {
    isValidCodes() {
      return this.recall.codes
    },
    isValidSection() {
      return this.recall.sectionId
    },
    isValidOrder() {
      return this.recall.orderId
    }
  }
}
</script>

<style lang="scss">
.recall-create {
  textarea {
    max-width: 100%;
    min-height: 100px;
  }
  .panel-body {
    height: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/configuration/recall/RecallCreate.vue